import { render, staticRenderFns } from "./LaborAdmin.vue?vue&type=template&id=324551ce"
import script from "./LaborAdmin.vue?vue&type=script&lang=js"
export * from "./LaborAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports